import { useMemo } from 'react';
import { ProfileRow, ProfileSection, ProfileSections } from '../../components/ProfileSection';
import { sortByStartDate } from '../../helpers';

interface Props {
    data: any[] | undefined;
};

export default function WorkExperience({ data }: Props) {
    const jobs = useMemo(() => sortByStartDate(data), [data]);

    return (
        <ProfileSections>
            {data && data.length === 0 && <span>No work experience.</span>}

            {jobs?.map((item, index) => <ProfileSection key={index} title={`Job ${index + 1}`}>
                <ProfileRow label='Job title'>{item.jobTitle}</ProfileRow>
                <ProfileRow label='Company'>{item.company}</ProfileRow>
                <ProfileRow label='Location'>{item.location}</ProfileRow>
                <ProfileRow label='Role description'>{item.roleDescription}</ProfileRow>
                <ProfileRow label='Date'>{item.from} - {item.to}</ProfileRow>
            </ProfileSection>)}
        </ProfileSections>
    );
};
